document.querySelectorAll('.cta').forEach( node => {
	node.querySelectorAll('.cta__content-wrap > *').forEach( ( c, i ) => {
		c.dataset.animation = 'lines';
		c.dataset.animationDelay = i * 200;
	} );

	const button = node.querySelector('.cta__button');

	if ( button ) {
		button.dataset.animation = 'block';
		button.dataset.animationDelay = '100';
	}
} );
